import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { map } from 'rxjs/operators';
import { BasketProductViewModel } from '@models/api-search.models';
import { ProductBrand } from '@models/api.models';
import { Observable } from 'rxjs';

@Pipe({
    name: 'brandLink',
    standalone: true
})
export class BrandLinkPipe implements PipeTransform {
    constructor(private readonly settingsService: SettingsService) {}

    transform(value: BasketProductViewModel['brand']): Observable<ProductBrand | undefined> {
        return this.settingsService.settings$.pipe(
            map(({ productSettings }) => productSettings?.brands?.find(item => item.brand === value?.key))
        );
    }
}
